import { Slider } from '@/components/ui/slider';
import { cn } from '@/utils';
import { ClassValue } from 'clsx';
import { RefObject, useEffect, useState } from 'react';

interface VolumeIconProps {
  volume: number;
  className: ClassValue;
}

function VolumeIcon({ volume, className }: VolumeIconProps) {
  if (volume === 0) {
    return <span className={cn('i-lucide-volume-x', className)} />;
  } else if (volume < 0.2) {
    return <span className={cn('i-lucide-volume', className)} />;
  } else if (volume < 0.7) {
    return <span className={cn('i-lucide-volume-1', className)} />;
  } else if (volume <= 1.0) {
    return <span className={cn('i-lucide-volume-2', className)} />;
  }
}

interface VolumeControlProps {
  className?: ClassValue;
  audioRef: RefObject<HTMLAudioElement | null>;
}

export function AudioPlayerVolumeControl({ className, audioRef }: VolumeControlProps) {
  const [volume, setVolume] = useState(0);
  const [mouseEnter, setMouseEnter] = useState<boolean>(false);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    setVolume(audio.volume);
    const handleVolumeChange = () => setVolume(audio.volume);
    audio.addEventListener('volumechange', handleVolumeChange);
    return () => {
      audio.removeEventListener('volumechange', handleVolumeChange);
    };
  }, [audioRef]);

  const onMouseEnter = () => {
    setMouseEnter(true);
  };
  const onMouseLeave = () => {
    setMouseEnter(false);
  };

  return (
    <div className={cn('cursor-pointer', className)} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {mouseEnter ? (
        <div className={'relative bottom-10 w-5'}>
          <Slider
            orientation={'vertical'}
            defaultValue={[volume]}
            min={0}
            max={1}
            step={0.01}
            onValueChange={(v) => {
              if (audioRef.current) {
                audioRef.current.volume = v[0];
              }
            }}
          />
        </div>
      ) : (
        <VolumeIcon className={'w-5'} volume={volume} />
      )}
    </div>
  );
}
